import React from 'react'
import folderPic from '../images/folder.png'

const SubComponentDocument = (props) => {
    var element = null
    if (props.ele.status !== 'OffboardedForever') {
        let localArrayTwo = []
        props.images.forEach( image => {
            if (image.driver_id === `https://backendpajamas.herokuapp.com/drivers/${props.ele.driver_id}/`) {
                localArrayTwo.push(image)
            }
        })
        let localEle = {...props.ele}
        localEle['imgArray'] = localArrayTwo
        element = (
            <h3 className='name_list_documents' onClick={(e, name )=> props.handleClick(e, localEle)}>
                {props.id+1}. {localEle.name} 
                <img src={folderPic} alt="Folder" className='image_in_documents_folder'/>
            </h3>
        )
    }
    return (
        <>
            {element}
        </>
    )
}

export default SubComponentDocument